import { useEffect, useState } from "react";
import merge from "lodash/merge";

import { getAmplisky, Variables } from "../utils/getAmplisky";

export function useSubscription<
  PropsType,
  SubscriptionType,
  TypedDocumentString,
>({
  initialData,
  graphQLDocument,
  variables,
  mergeData = true,
  transform = (subscriptionData) => subscriptionData as unknown as PropsType,
  enabled = true,
}: {
  initialData: PropsType;
  graphQLDocument: TypedDocumentString;
  variables?: Variables;
  mergeData?: boolean;
  enabled?: boolean;
  transform?: (subscriptionData: SubscriptionType) => PropsType;
}) {
  const [props, setProps] = useState<PropsType>(initialData);

  useEffect(() => {
    if (!enabled) {
      return;
    }
    const amplisky = getAmplisky();
    if (!amplisky) {
      console.warn("useSubscription: amplisky not found");
      return;
    }

    const subscription = amplisky
      .subscription(cleanGraphQLDocument(graphQLDocument), variables || {})
      .subscribe({
        // @ts-ignore overload error
        next: (subscriptionData: SubscriptionType) => {
          const transformedData = transform(
            subscriptionData as SubscriptionType
          );
          setProps(
            mergeData ? merge({}, props, transformedData) : transformedData
          );
        },
        error: (error: any) => {
          console.error(error);
        },
      });

    return () => {
      subscription?.unsubscribe();
    };
  }, [enabled]);

  return props as PropsType;
}

function cleanGraphQLDocument(document: any) {
  return document.toString().replace(/\s+/g, " ").trim();
}
